<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Manual AML Check</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="manualCheck" autocomplete="off">

     <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Date</label>
      <div class="col-sm-9">
        <input type="date" 
               class="form-control" 
               formControlName="date">
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Notes</label>
      <textarea class="form-control" 
                #notes
                formControlName="notes" 
                placeholder="Notes"
                maxlength="300"
                rows="4"></textarea>
      <div class="form-text text-end">{{notes.value?.length || 0}}/300</div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-success" 
          (click)="onConfirm()">
    Confirm
  </button>
</div>
